import { BackgroundVideo, type BackgroundVideoProps } from '@/components/atoms/BackgroundVideo';
import React from 'react';
import { StyleSheet, View, ViewProps, ViewStyle } from 'react-native';

export interface SplashVideoProps {
    style?: ViewProps['style'];
}

export function SplashVideo({ style }: SplashVideoProps) {
    const props: BackgroundVideoProps = {
        // Web-only landscape splash video
        localSource: require('@assets/video/splash-landscape1.mp4'),
        style: styles.video,
        videoStyle: [styles.video, webVideoCenter],
        contentFit: 'contain', // avoid cropping; center via objectPosition
        placeholderImage: require('@assets/images/splash-icon.png'),
    };

    return (
        <View style={[styles.wrapper, style]}>
            <BackgroundVideo {...props} />
        </View>
    );
}

const styles = StyleSheet.create({
    wrapper: {
        width: '100%',
        height: '100%',
        justifyContent: 'center',
        alignItems: 'center',
    },
    video: {
        width: '100%',
        height: '100%',
    },
});

const webVideoCenter = {
    objectPosition: 'center',
} as ViewStyle;

export default SplashVideo;


